// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const AffectedPin = t.struct({
    baseMachineCode: t.String,
    completedDate: t.Number,
    customerSummary: CustomerSummary,
    dealer: Dealer,
    internalRecall: t.String,
    labor: t.String,
    model: t.String,
    parts: t.String,
    pin: t.String,
    pipCode: t.String,
    pipCompletionStatus: KeyValuePair
}, {
    name: 'AffectedPin',
    strict: true
});

export const getDefaultState = () => new AffectedPin({
    baseMachineCode: '',
    completedDate: 0,
    customerSummary: getCustomerSummaryDefaultState(),
    dealer: getDealerDefaultState(),
    internalRecall: '',
    labor: '',
    model: '',
    parts: '',
    pin: '',
    pipCode: '',
    pipCompletionStatus: getKeyValuePairDefaultState()
});

export default AffectedPin;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/affected-pin.js